import { render, staticRenderFns } from "./LoginFooter.vue?vue&type=template&id=f7c59212&scoped=true"
import script from "./LoginFooter.vue?vue&type=script&lang=js"
export * from "./LoginFooter.vue?vue&type=script&lang=js"
import style0 from "./LoginFooter.vue?vue&type=style&index=0&id=f7c59212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c59212",
  null
  
)

export default component.exports